<template>
  <bootstrap-modal
    :modal-title="`您尚未登入${type[authType]}帳號`"
    :is-open="isModalOpen"
    size="sm"
    @modal:close="closeRedirectModal"
    @modal:okay="agreeToRedirect"
  >
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-10 mb-4">
          <p class="text-center">
            前往{{ `${type[authType]}` }}專區?
          </p>
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>
<script>
import BootstrapModal from '~bootstrap/Modal'
export default {
  name: 'RedirectLoginPageModal',
  components: {
    BootstrapModal
  },
  props: {
    isModalOpen: Boolean,
    authType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      type: {
        student: '學生',
        enterprise: '企業'
      }
    }
  },
  methods: {
    closeRedirectModal () {
      this.$emit('modal:close')
    },
    agreeToRedirect () {
      this.$emit('modal:close')
      setTimeout(() => {
        this.$router.push({
          path: `/login/${this.authType}`
        })
      }, 500)
    }
  }
}
</script>
